import '../assets/NcAssistantButton-owGSr0s0.css';
import { f as mdiCreation } from "./mdi-CgetWrFc.mjs";
import { N as NcAssistantIcon } from "./NcAssistantIcon-CKWZRzXg.mjs";
import { N as NcButton } from "./NcButton-Dz2O6cSU.mjs";
import { N as NcIconSvgWrapper } from "./NcIconSvgWrapper-Bui9PhAS.mjs";
import { n as normalizeComponent } from "./_plugin-vue2_normalizer-DU4iP6Vu.mjs";
const assistantButton = "_assistantButton_1xe1x_20";
const assistantButton_disabled = "_assistantButton_disabled_1xe1x_30";
const assistantButton_primary = "_assistantButton_primary_1xe1x_34";
const assistantButton__icon = "_assistantButton__icon_1xe1x_38";
const assistantButton__text = "_assistantButton__text_1xe1x_39";
const assistantButton__button = "_assistantButton__button_1xe1x_42";
const style0 = {
  "material-design-icon": "_material-design-icon_1xe1x_12",
  assistantButton,
  assistantButton_disabled,
  assistantButton_primary,
  assistantButton__icon,
  assistantButton__text,
  assistantButton__button
};
const _sfc_main = {
  __name: "NcAssistantButton",
  props: {
    /**
     * Toggles the disabled state of the button on and off.
     */
    disabled: {
      type: Boolean,
      default: false
    },
    /**
     * The readable text of the button.
     * Can be overriden by using the `default` slot.
     *
     * If neither this is set nor the `default` slot is used, you will have to set at least `aria-label` or `aria-labelledby`.
     */
    text: {
      type: String,
      default: ""
    },
    /**
     * The button variant.
     * In most cases the `secondary` style should be used.
     */
    variant: {
      type: String,
      default: "secondary"
    }
  },
  emits: [
    /**
     * The mouse click event when the button is triggered.
     */
    "click"
  ],
  setup(__props) {
    return { __sfc: true, mdiCreation, NcAssistantIcon, NcButton, NcIconSvgWrapper };
  }
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { class: [{
    [_vm.$style.assistantButton_disabled]: _vm.disabled,
    [_vm.$style.assistantButton_primary]: _vm.variant === "primary"
  }, _vm.$style.assistantButton] }, [_c(_setup.NcButton, { class: _vm.$style.assistantButton__button, attrs: { "disabled": _vm.disabled, "variant": "tertiary" }, on: { "click": function($event) {
    return _vm.$emit("click", $event);
  } }, scopedSlots: _vm._u([{ key: "icon", fn: function() {
    return [_vm.variant === "primary" ? _c(_setup.NcIconSvgWrapper, { class: _vm.$style.assistantButton__icon, attrs: { "path": _setup.mdiCreation } }) : _c(_setup.NcAssistantIcon)];
  }, proxy: true }, _vm.text || _vm.$scopedSlots.default ? { key: "default", fn: function() {
    return [_c("div", { class: _vm.$style.assistantButton__text }, [_vm._t("default", function() {
      return [_vm._v(_vm._s(_vm.text))];
    })], 2)];
  }, proxy: true } : null], null, true) })], 1);
};
var _sfc_staticRenderFns = [];
const __cssModules = {
  "$style": style0
};
function _sfc_injectStyles(ctx) {
  for (var key in __cssModules) {
    this[key] = __cssModules[key];
  }
}
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  _sfc_injectStyles,
  null
);
const NcAssistantButton = __component__.exports;
export {
  NcAssistantButton as N
};
//# sourceMappingURL=NcAssistantButton-BPXX2mz6.mjs.map
